module.exports = "https://r.zoocdn.com/_next/static/images/propertyPins-home-default-e691903c4b96edb3b762da6fd47d87a3.png";